//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { columnMap } from '../../../shared/table/models/column-map.decorator';
import { keyMap } from '../../../shared/table/models/key-map.decorator';

export class Country implements ICountry {
    id?: string | null;
    name?: string | null;
    region?: RegionEnum;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        return data;
    }
}

export interface ICountry {
    id?: string | null;
    name?: string | null;
    region?: RegionEnum;
}

export enum RegionEnum {
    Africa = 1,
    America = 2,
    Asia = 4,
    Europe = 8,
    Oceania = 16,
}

export class FileValidationModel implements IFileValidationModel {
    extensions?: string[] | null;
    height?: number;
    width?: number;
    maxSizeInMb?: number;
    maxTotalSizeInMb?: number;
    latexInZipIsRequired?: boolean;

    constructor(data?: IFileValidationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(item);
            }
            else {
                this.extensions = null as any;
            }
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.maxSizeInMb = _data["maxSizeInMb"] !== undefined ? _data["maxSizeInMb"] : null as any;
            this.maxTotalSizeInMb = _data["maxTotalSizeInMb"] !== undefined ? _data["maxTotalSizeInMb"] : null as any;
            this.latexInZipIsRequired = _data["latexInZipIsRequired"] !== undefined ? _data["latexInZipIsRequired"] : null as any;
        }
    }

    static fromJS(data: any): FileValidationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileValidationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item);
        }
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["maxSizeInMb"] = this.maxSizeInMb !== undefined ? this.maxSizeInMb : null as any;
        data["maxTotalSizeInMb"] = this.maxTotalSizeInMb !== undefined ? this.maxTotalSizeInMb : null as any;
        data["latexInZipIsRequired"] = this.latexInZipIsRequired !== undefined ? this.latexInZipIsRequired : null as any;
        return data;
    }
}

export interface IFileValidationModel {
    extensions?: string[] | null;
    height?: number;
    width?: number;
    maxSizeInMb?: number;
    maxTotalSizeInMb?: number;
    latexInZipIsRequired?: boolean;
}

export class ApiActivity implements IApiActivity {
    creatorId?: number;
    creatorFullName?: string | null;
    modifierId?: number | null;
    modifierFullName?: string | null;
    lastModifiedDate?: Date | null;
    createdDateTime?: Date;

    constructor(data?: IApiActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.creatorFullName = _data["creatorFullName"] !== undefined ? _data["creatorFullName"] : null as any;
            this.modifierId = _data["modifierId"] !== undefined ? _data["modifierId"] : null as any;
            this.modifierFullName = _data["modifierFullName"] !== undefined ? _data["modifierFullName"] : null as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["creatorFullName"] = this.creatorFullName !== undefined ? this.creatorFullName : null as any;
        data["modifierId"] = this.modifierId !== undefined ? this.modifierId : null as any;
        data["modifierFullName"] = this.modifierFullName !== undefined ? this.modifierFullName : null as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiActivity {
    creatorId?: number;
    creatorFullName?: string | null;
    modifierId?: number | null;
    modifierFullName?: string | null;
    lastModifiedDate?: Date | null;
    createdDateTime?: Date;
}

export class ApiBackgroundProcessMessage implements IApiBackgroundProcessMessage {
    jobId?: string | null;
    process?: BackgroundProcessEnum;
    services?: ServicesEnum;
    jobData?: any | null;
    status?: BackgroundProcessStatusEnum;
    progressValue?: number;
    completed?: boolean;
    inProgress?: boolean;

    constructor(data?: IApiBackgroundProcessMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : null as any;
            this.process = _data["process"] !== undefined ? _data["process"] : null as any;
            this.services = _data["services"] !== undefined ? _data["services"] : null as any;
            this.jobData = _data["jobData"] !== undefined ? _data["jobData"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.progressValue = _data["progressValue"] !== undefined ? _data["progressValue"] : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : null as any;
        }
    }

    static fromJS(data: any): ApiBackgroundProcessMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBackgroundProcessMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : null as any;
        data["process"] = this.process !== undefined ? this.process : null as any;
        data["services"] = this.services !== undefined ? this.services : null as any;
        data["jobData"] = this.jobData !== undefined ? this.jobData : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["progressValue"] = this.progressValue !== undefined ? this.progressValue : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : null as any;
        return data;
    }
}

export interface IApiBackgroundProcessMessage {
    jobId?: string | null;
    process?: BackgroundProcessEnum;
    services?: ServicesEnum;
    jobData?: any | null;
    status?: BackgroundProcessStatusEnum;
    progressValue?: number;
    completed?: boolean;
    inProgress?: boolean;
}

export enum BackgroundProcessEnum {
    PaperParsingCorrectFromDoc = 0,
    LoadReferencesFromPdf = 1,
    LoadReferencesFromDocOrPdf = 2,
    LoadReferencesManually = 3,
    RequestDOIFromCrossref = 4,
    PrepareFirstCheck = 5,
    LoadReferencesForTechnicalCheck = 6,
    PrepareDoubleCheck = 7,
    PrepareTripleCheck = 8,
    ReImportPaperDocuments = 9,
    PrepareTocRead = 10,
    PrepareAuthorShortRead = 11,
    PrepareCheckerShortRead = 12,
    GenerateTitleEditorKeywordIndex = 13,
    GenerateTitleEditorTableOfContents = 14,
    CheckProjectForPlagiarism = 15,
    GeneratePrepressPrint = 16,
    GeneratePrepressEbook = 17,
    GenerateShortDoc = 18,
    GenerateShortDb = 19,
    GenerateTocFile = 20,
    GenerateKeywordIndexFile = 21,
    GenerateHomePrintPage = 22,
    GenerateAuthorIndex = 23,
    ReviewerBulkCreate = 24,
    AuthorBulkCreate = 25,
    GeneratePartPrepressPrint = 26,
    DataPumpCheckAll = 27,
    DataPumpTitle = 28,
    DataPumpJournal = 29,
    DataPumpPaper = 30,
    CheckDoiEmail = 35,
    SavedSearch = 40,
    CountryIpRange = 45,
    Grid = 50,
    CounterReportAggregator = 55,
    SendGridBounces = 60,
    RelatedPapers = 65,
    PrepareSendGridRelatedPapersCampaign = 70,
    PrepareSendGridMailingCampaign = 71,
    UpdateMarketingCampaignFromSendGrid = 75,
    CleanUpAllSendGridContacts = 80,
    PdfProcessor = 85,
    CreatePotentialCustomersCampaign = 90,
    TrackingNumbersSync = 95,
    GenerateListOfReviewers = 100,
    ConvertAllPapersEpub = 105,
    GenerateEbookEpub = 110,
}

export enum ServicesEnum {
    Accounts = 0,
    Mailing = 1,
    Publishing = 2,
    Tasks = 3,
    TechnicalCheck = 4,
    EditingTool = 5,
    ContentManager = 6,
    Shared = 7,
    Promotion = 9,
    DataPump = 10,
    AuditTrails = 11,
    Search = 12,
    CounterReportAggregator = 13,
    MarketingCampaigns = 14,
    PdfProcessor = 15,
    TrackingNumbers = 16,
    Ai = 17,
    Default = 999,
}

export enum BackgroundProcessStatusEnum {
    None = 0,
    Enqueued = 1,
    Started = 2,
    Succeeded = 3,
    Failed = 4,
    Canceled = 5,
    Unfinished = 6,
}

export class ApiCreateMemberRequest implements IApiCreateMemberRequest {
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    sendVerificationLink?: boolean;

    constructor(data?: IApiCreateMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.sendVerificationLink = _data["sendVerificationLink"] !== undefined ? _data["sendVerificationLink"] : null as any;
        }
    }

    static fromJS(data: any): ApiCreateMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCreateMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["sendVerificationLink"] = this.sendVerificationLink !== undefined ? this.sendVerificationLink : null as any;
        return data;
    }
}

export interface IApiCreateMemberRequest {
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    sendVerificationLink?: boolean;
}

export class ApiCreatorInfo implements IApiCreatorInfo {
    id?: number;
    fullName?: string | null;
    createdDate?: Date;

    constructor(data?: IApiCreatorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiCreatorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCreatorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        return data;
    }
}

export interface IApiCreatorInfo {
    id?: number;
    fullName?: string | null;
    createdDate?: Date;
}

export class ApiDateRange implements IApiDateRange {
    from?: Date | null;
    to?: Date | null;

    constructor(data?: IApiDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new ApiDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IApiDateRange {
    from?: Date | null;
    to?: Date | null;
}

export class ApiExternalAccountInfo implements IApiExternalAccountInfo {
    deactivated?: boolean;
    notVerified?: boolean;
    exists?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    accountId?: string | null;

    constructor(data?: IApiExternalAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deactivated = _data["deactivated"] !== undefined ? _data["deactivated"] : null as any;
            this.notVerified = _data["notVerified"] !== undefined ? _data["notVerified"] : null as any;
            this.exists = _data["exists"] !== undefined ? _data["exists"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): ApiExternalAccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiExternalAccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deactivated"] = this.deactivated !== undefined ? this.deactivated : null as any;
        data["notVerified"] = this.notVerified !== undefined ? this.notVerified : null as any;
        data["exists"] = this.exists !== undefined ? this.exists : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }
}

export interface IApiExternalAccountInfo {
    deactivated?: boolean;
    notVerified?: boolean;
    exists?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    accountId?: string | null;
}

export class ApiFileInfo implements IApiFileInfo {
    storagePath?: string | null;
    storageName?: string | null;
    originalName?: string | null;
    size?: number;
    extension?: string | null;
    createdDateTime?: Date | null;

    constructor(data?: IApiFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storagePath = _data["storagePath"] !== undefined ? _data["storagePath"] : null as any;
            this.storageName = _data["storageName"] !== undefined ? _data["storageName"] : null as any;
            this.originalName = _data["originalName"] !== undefined ? _data["originalName"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storagePath"] = this.storagePath !== undefined ? this.storagePath : null as any;
        data["storageName"] = this.storageName !== undefined ? this.storageName : null as any;
        data["originalName"] = this.originalName !== undefined ? this.originalName : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["extension"] = this.extension !== undefined ? this.extension : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiFileInfo {
    storagePath?: string | null;
    storageName?: string | null;
    originalName?: string | null;
    size?: number;
    extension?: string | null;
    createdDateTime?: Date | null;
}

export class ApiIdNameItem implements IApiIdNameItem {
    id?: number;
    name?: string | null;

    constructor(data?: IApiIdNameItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiIdNameItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiIdNameItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiIdNameItem {
    id?: number;
    name?: string | null;
}

export class ApiListItemPosition implements IApiListItemPosition {
    id?: number;
    pos?: number;

    constructor(data?: IApiListItemPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
        }
    }

    static fromJS(data: any): ApiListItemPosition {
        data = typeof data === 'object' ? data : {};
        let result = new ApiListItemPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        return data;
    }
}

export interface IApiListItemPosition {
    id?: number;
    pos?: number;
}

export class ApiMemberInfo implements IApiMemberInfo {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    fullNameAndTitle?: string | null;
    email?: string | null;
    fullNameEmailAndId?: string | null;
    hasAvatar?: boolean;

    constructor(data?: IApiMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.fullNameAndTitle = _data["fullNameAndTitle"] !== undefined ? _data["fullNameAndTitle"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.fullNameEmailAndId = _data["fullNameEmailAndId"] !== undefined ? _data["fullNameEmailAndId"] : null as any;
            this.hasAvatar = _data["hasAvatar"] !== undefined ? _data["hasAvatar"] : null as any;
        }
    }

    static fromJS(data: any): ApiMemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["fullNameAndTitle"] = this.fullNameAndTitle !== undefined ? this.fullNameAndTitle : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["fullNameEmailAndId"] = this.fullNameEmailAndId !== undefined ? this.fullNameEmailAndId : null as any;
        data["hasAvatar"] = this.hasAvatar !== undefined ? this.hasAvatar : null as any;
        return data;
    }
}

export interface IApiMemberInfo {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    fullNameAndTitle?: string | null;
    email?: string | null;
    fullNameEmailAndId?: string | null;
    hasAvatar?: boolean;
}

export class ApiNamedListItem implements IApiNamedListItem {
    id?: string | null;
    name?: string | null;

    constructor(data?: IApiNamedListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiNamedListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiNamedListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiNamedListItem {
    id?: string | null;
    name?: string | null;
}

export class ApiNote implements IApiNote {
    description?: string | null;
    type?: NoteTypeEnum;
    attachmentName?: string | null;

    constructor(data?: IApiNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
        }
    }

    static fromJS(data: any): ApiNote {
        data = typeof data === 'object' ? data : {};
        let result = new ApiNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        return data;
    }
}

export interface IApiNote {
    description?: string | null;
    type?: NoteTypeEnum;
    attachmentName?: string | null;
}

export enum NoteTypeEnum {
    None = 0,
    Comment = 1,
    DoublePr = 2,
    TriplePr = 3,
    Subscription = 4,
    EditorComment = 5,
    AuthorComment = 6,
}

export class ApiNoteListItem implements IApiNoteListItem {
    @keyMap()
    id?: number;
    createdDateTime?: Date;
    @columnMap(() => String)
    description?: string | null;
    @columnMap(() => NoteTypeEnum)
    type?: NoteTypeEnum;
    @columnMap(() => ApiIdNameItem)
    createdBy?: ApiIdNameItem | null;
    @columnMap(() => Date)
    lastUpdated?: Date;
    @columnMap(() => ApiFileInfo)
    attachment?: ApiFileInfo | null;
    isEditable?: boolean;

    constructor(data?: IApiNoteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.createdBy = _data["createdBy"] ? ApiIdNameItem.fromJS(_data["createdBy"]) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.attachment = _data["attachment"] ? ApiFileInfo.fromJS(_data["attachment"]) : null as any;
            this.isEditable = _data["isEditable"] !== undefined ? _data["isEditable"] : null as any;
        }
    }

    static fromJS(data: any): ApiNoteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiNoteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : null as any;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : null as any;
        return data;
    }
}

export interface IApiNoteListItem {
    id?: number;
    createdDateTime?: Date;
    description?: string | null;
    type?: NoteTypeEnum;
    createdBy?: ApiIdNameItem | null;
    lastUpdated?: Date;
    attachment?: ApiFileInfo | null;
    isEditable?: boolean;
}

export class ApiRange implements IApiRange {
    begin?: number;
    end?: number;

    constructor(data?: IApiRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.begin = _data["begin"] !== undefined ? _data["begin"] : null as any;
            this.end = _data["end"] !== undefined ? _data["end"] : null as any;
        }
    }

    static fromJS(data: any): ApiRange {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["begin"] = this.begin !== undefined ? this.begin : null as any;
        data["end"] = this.end !== undefined ? this.end : null as any;
        return data;
    }
}

export interface IApiRange {
    begin?: number;
    end?: number;
}

export class ApiSharedAttachmentListItem implements IApiSharedAttachmentListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiFileInfo)
    file?: ApiFileInfo | null;
    @columnMap(() => ApiMemberInfo)
    uploadedBy?: ApiMemberInfo | null;
    @columnMap(() => Date)
    added?: Date;

    constructor(data?: IApiSharedAttachmentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.uploadedBy = _data["uploadedBy"] ? ApiMemberInfo.fromJS(_data["uploadedBy"]) : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiSharedAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSharedAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        return data;
    }
}

export interface IApiSharedAttachmentListItem {
    id?: number;
    file?: ApiFileInfo | null;
    uploadedBy?: ApiMemberInfo | null;
    added?: Date;
}

export class ApiSignalRError implements IApiSignalRError {
    message?: string | null;
    details?: any | null;

    constructor(data?: IApiSignalRError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.details = _data["details"] !== undefined ? _data["details"] : null as any;
        }
    }

    static fromJS(data: any): ApiSignalRError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSignalRError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["details"] = this.details !== undefined ? this.details : null as any;
        return data;
    }
}

export interface IApiSignalRError {
    message?: string | null;
    details?: any | null;
}

export class ApiText implements IApiText {
    text?: string | null;

    constructor(data?: IApiText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): ApiText {
        data = typeof data === 'object' ? data : {};
        let result = new ApiText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IApiText {
    text?: string | null;
}

export enum ActionsEnum {
    Create = 0,
    Read = 1,
    Update = 2,
    Delete = 3,
}

export enum ApiErrorCode {
    CaptchaValidationFailed = 1001,
}

export enum BackgroundProcessStepStatus {
    None = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
}

export enum BackgroundProcessType {
    Hangfire = 0,
    Job = 1,
}

export enum EntityAuditAction {
    Create = 0,
    Update = 1,
    Add = 2,
    Remove = 3,
    Reorder = 4,
}

export enum FileUploadErrorEnum {
    VersionAlreadyImported = 0,
    InvalidFile = 1,
    WrongExtension = 2,
    ExceededSize = 3,
    MissingSize = 4,
    ZipDoesNotContainTex = 5,
    WrongHeight = 6,
    WrongWidth = 7,
    FileNameNumericOnly = 8,
    RepeatedPageFrom = 9,
    Encrypted = 10,
    FileHasNoPair = 11,
    CannotReplace = 12,
    BulkFileContainsErrors = 13,
    MaxFileCount = 14,
    EmailIsRequired = 15,
    InvalidPaperId = 16,
}

export enum Gender {
    Female = 0,
    Male = 1,
    NonBinary = 2,
}

export enum Module {
    AccountMembers = 1001,
    AccountOrganizations = 1002,
    AccountRoles = 1003,
    AccountSettings = 1004,
    AccountGroups = 1005,
    PublishingJournals = 1200,
    PublishingJournalGroups = 1201,
    PublishingSettings = 1202,
    PublishingSubjectCategories = 1203,
    PublishingTitles = 1204,
    PublishingIsbns = 1205,
    PublishingPapers = 1206,
    PublishingDoiManagement = 1208,
    PublishingMemberProxy = 1209,
    TechnicalCheckManagement = 1300,
    TechnicalCheckCheckerTool = 1301,
    PromotionProjects = 1500,
    PromotionSettings = 1501,
    DataPump = 1600,
    AuditTrails = 1700,
    TimerTasks = 1800,
    BackgroundProcesses = 1801,
    Shared = 1900,
    CounterReportAggregator = 2000,
    Mailing = 2100,
    MarketingCampaignsRelatedPapers = 2200,
    MarketingCampaignsNewsletter = 2202,
    MarketingCampaignsPotentialCustomers = 2203,
    PdfProcessor = 2300,
    TrackingNumbers = 2400,
    Ai = 2500,
    EventBusErrorQueues = 2600,
    EditingTool = 5000,
    EditingToolAuthor = 5001,
    EditingToolEditor = 5002,
    EditingToolReviewer = 5003,
    ContentManager = 6000,
    ContentEditor = 6001,
    Search = 7000,
    Default = 2147483647,
}

export enum Permission {
    Unspecified = 0,
    MailingView = 10,
    MailingEdit = 11,
    MailingCreate = 12,
    MailingDelete = 13,
    AccountMembersView = 30,
    AccountMembersEdit = 31,
    AccountMembersCreate = 32,
    AccountMembersDelete = 33,
    AccountMembersLoginAs = 34,
    AccountOrganizationsView = 40,
    AccountOrganizationsEdit = 41,
    AccountOrganizationsCreate = 42,
    AccountOrganizationsDelete = 43,
    AccountOrganizationsMakePublic = 44,
    AccountRolesView = 50,
    AccountRolesEdit = 51,
    AccountRolesCreate = 52,
    AccountRolesDelete = 53,
    AccountRolesManageUserRoles = 54,
    AccountSettingsView = 60,
    AccountSettingsEdit = 61,
    AccountSettingsCreate = 62,
    AccountSettingsDelete = 63,
    AccountGroupsView = 70,
    AccountGroupsEdit = 71,
    AccountGroupsCreate = 72,
    AccountGroupsDelete = 73,
    PublishingJournalsView = 80,
    PublishingJournalsEdit = 81,
    PublishingJournalsCreate = 82,
    PublishingJournalsDelete = 83,
    PublishingJournalGroupsView = 90,
    PublishingJournalGroupsEdit = 91,
    PublishingJournalGroupsCreate = 92,
    PublishingJournalGroupsDelete = 93,
    PublishingSettingsView = 100,
    PublishingSettingsEdit = 101,
    PublishingSettingsCreate = 102,
    PublishingSettingsDelete = 103,
    PublishingSubjectCategoriesView = 110,
    PublishingSubjectCategoriesEdit = 111,
    PublishingSubjectCategoriesCreate = 112,
    PublishingSubjectCategoriesDelete = 113,
    PublishingTitlesView = 120,
    PublishingTitlesEdit = 121,
    PublishingTitlesCreate = 122,
    PublishingTitlesDelete = 123,
    PublishingIsbnsView = 130,
    PublishingIsbnsEdit = 131,
    PublishingIsbnsCreate = 132,
    PublishingIsbnsDelete = 133,
    PublishingPapersView = 140,
    PublishingPapersEdit = 141,
    PublishingPapersCreate = 142,
    PublishingPapersDelete = 143,
    TechnicalCheckManagementView = 160,
    TechnicalCheckManagementEdit = 161,
    TechnicalCheckManagementCreate = 162,
    TechnicalCheckManagementDelete = 163,
    TechnicalCheckCheckerToolView = 170,
    TechnicalCheckCheckerToolEdit = 171,
    TechnicalCheckCheckerToolCreate = 172,
    TechnicalCheckCheckerToolDelete = 173,
    PromotionProjectsView = 190,
    PromotionProjectsEdit = 191,
    PromotionProjectsCreate = 192,
    PromotionProjectsDelete = 193,
    PromotionSettingsView = 200,
    PromotionSettingsEdit = 201,
    PromotionSettingsCreate = 202,
    PromotionSettingsDelete = 203,
    EditingToolView = 210,
    EditingToolEdit = 211,
    EditingToolCreate = 212,
    EditingToolDelete = 213,
    EditingToolAuthorView = 220,
    EditingToolAuthorEdit = 221,
    EditingToolAuthorCreate = 222,
    EditingToolAuthorDelete = 223,
    EditingToolEditorView = 230,
    EditingToolEditorEdit = 231,
    EditingToolEditorCreate = 232,
    EditingToolEditorDelete = 233,
    EditingToolReviewerView = 240,
    EditingToolReviewerEdit = 241,
    EditingToolReviewerCreate = 242,
    EditingToolReviewerDelete = 243,
    ContentManagerView = 250,
    ContentManagerEdit = 251,
    ContentManagerCreate = 252,
    ContentManagerDelete = 253,
    ContentEditorView = 260,
    ContentEditorEdit = 261,
    ContentEditorCreate = 262,
    ContentEditorDelete = 263,
    PublishingDoiManagementView = 270,
    PublishingDoiManagementEdit = 271,
    PublishingDoiManagementCreate = 272,
    PublishingMemberProxyView = 280,
    AuditTrailsView = 290,
    TimerTasksView = 300,
    TimerTasksEdit = 301,
    TimerTasksCreate = 302,
    TimerTasksDelete = 303,
    BackgroundProcessesView = 310,
    MarketingCampaignsRelatedPapersView = 320,
    MarketingCampaignsRelatedPapersEdit = 321,
    MarketingCampaignsRelatedPapersCreate = 322,
    MarketingCampaignsRelatedPapersDelete = 323,
    MarketingCampaignsNewsletterView = 340,
    MarketingCampaignsNewsletterEdit = 341,
    MarketingCampaignsNewsletterCreate = 342,
    MarketingCampaignsNewsletterDelete = 343,
    MarketingCampaignsPotentialCustomersView = 350,
    MarketingCampaignsPotentialCustomersEdit = 351,
    MarketingCampaignsPotentialCustomersCreate = 352,
    MarketingCampaignsPotentialCustomersDelete = 353,
    TrackingNumbersView = 380,
    TrackingNumbersEdit = 381,
    TrackingNumbersCreate = 382,
    TrackingNumbersDelete = 383,
    AiView = 390,
    AiEdit = 391,
    AiCreate = 392,
    AiDelete = 393,
    EventBusErrorQueuesView = 400,
    EventBusErrorQueuesEdit = 401,
    EventBusErrorQueuesDelete = 402,
}

export enum SectionsEnum {
    Addresses = 0,
    Affiliation = 1,
    Details = 2,
    Attachments = 3,
    Notes = 4,
    Avatar = 5,
    Roles = 6,
    Settings = 7,
    Membership = 8,
    Mails = 9,
    Identity = 10,
    HeadOfCompany = 11,
    Groups = 12,
    GroupAdmin = 13,
    ReasonNotes = 14,
    Members = 15,
    Organizations = 16,
    Responsibilities = 17,
    JournalGroups = 18,
    JournalFile = 19,
    EditorialBoard = 20,
    JournalTopics = 21,
    ThemaCategories = 22,
    Description = 23,
    Isbns = 24,
    Pricing = 25,
    TitleTopics = 26,
    JournalResponsibilities = 27,
    TitleEditors = 28,
    TitleJournal = 29,
    TitleDescription = 30,
    TitleReviewers = 31,
    TitleAuthors = 32,
    PaperAuthors = 33,
    PaperTopics = 35,
    PaperDocuments = 36,
    PaperAbstract = 37,
    TitlePapers = 38,
    PaperDocumentsFilesHistory = 39,
    Covers = 40,
    PaperReferences = 41,
    Chapters = 42,
    Keywords = 43,
    JournalReviewerSettings = 44,
    TitleContributors = 45,
    TitleOperations = 46,
    DiscountedTitles = 47,
    PaperChecklist = 48,
    PaperCopyright = 49,
    PaperReviews = 50,
    TitleChecklist = 51,
    TitleDocuments = 52,
    Titles = 53,
    ContentEditors = 54,
    Project = 55,
    PaperDetails = 56,
    PaperState = 57,
    Tags = 58,
    Contacts = 59,
    Contracts = 60,
    RelatedProjects = 61,
    TitleParts = 62,
    JournalSubscriptionSettings = 63,
    PublicData = 64,
    Scinet5 = 65,
    PaperFooters = 66,
    CustomLinksPages = 67,
    Default = 999,
}

export enum SocialNetworkEnum {
    Google = 0,
    Facebook = 1,
    LinkedIn = 2,
    Mendeley = 3,
    Orcid = 4,
}

export enum TimerTaskType {
    CountryIpRange = 1,
    Grid = 2,
    SavedSearch = 3,
    CounterReportAggregator = 4,
    SendGridBounces = 5,
    UpdateMarketingCampaignFromSendGrid = 6,
    CleanUpAllSendGridContacts = 7,
    PdfProcessor = 8,
    TrackingNumbersSync = 9,
}

export enum OperationMode {
    Disabled = 0,
    Test = 1,
    Enabled = 2,
}

/* tslint:disable */
/* eslint-disable */